import React from 'react';
import ModalFrame from '../../ModalFrame';
import ScoreAllReport from './ScoreAllReport';

class ModalScoreAllReportController extends React.Component {
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);

  }


  hideModal() {
    const {setModalInfo, confirmHandler} = this.props;
    setModalInfo({});
    confirmHandler();
  }

  render() {
    const {modalInfo, confirmHandler} = this.props;
    return (
      <div className="example-modal">
        {modalInfo.name === 'scoreAllTranscript' ?
          <ModalFrame
            title="ALL SCORES REPORT"
            desktopWidth="90%"
            headerCloseButtonHandler={this.hideModal}
            hasHeader={true}>
            <ScoreAllReport
              modalInfo={modalInfo}
              hideModal={this.hideModal}
              confirmHandler={confirmHandler}
            />
          </ModalFrame> : null}
      </div>
    )
  }
}

export default ModalScoreAllReportController;